import worker from './volume-process.worker.js'

class VolumeAudioContext {
  constructor(callback) {
    this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
    this.audioContext.audioWorklet.addModule(worker).then(() => {
      callback && callback()
    }).catch(e => {
      console.log('audioWorklet addModule error:', e)
      callback && callback()
    })
    this.volumeNode = {}
    this.startTime = {}
    this.callbackMap = {}
    this.paramterData = {
      clipLevel: 0.98,
      averaging: 0.99,
      clipLag: 750
    }
  }

  async addAudioTrack (key, audioTrack, callback) {
    if (!key || !audioTrack) {
      console.log('please to confirm has audiorack key and audiotrack')
      return
    }
    if (!this.audioContext || this.audioContext.state === 'closed') return
    // 浏览器不允许自动播放，所以要添加 resume
    if (this.audioContext.state === 'suspended') this.audioContext.resume()
    await this.audioContext.audioWorklet.addModule(worker)
    this.startTime[key] = new Date().getTime()
    this.volumeNode[key] = new AudioWorkletNode(this.audioContext, 'volume-processor', {
      processorOptions: this.paramterData
    })
    // 标记这个key是活跃的
    this.callbackMap[key] = true
    const mediaStream = new MediaStream()
    mediaStream.addTrack(audioTrack)
    const mediaStreamSource = this.audioContext.createMediaStreamSource(mediaStream)
    mediaStreamSource.connect(this.volumeNode[key]).connect(this.audioContext.destination)
    if (callback) {
      this.volumeNode[key].port.onmessage = event => {
        // 检查这个track是否已经被标记为需要清理
        if (!this.callbackMap[key]) {
          return // 如果已经被标记清理，忽略后续消息
        }
        const data = event.data
        if (data) {
          const volumeLeft = this.dealVolume(data.volume[0])
          const volumeRight = this.dealVolume(data.volume[1])
          const currentTime = new Date().getTime()
          if (currentTime - this.startTime[key] > 100) {
            this.startTime[key] = currentTime
            callback(volumeLeft, volumeRight)
          }
        }
      }
    }
    // console.log('活跃Worker keys:', this.getActiveWorkerKeys())
  }

  dealVolume (volume) {
    const percentage = Math.floor(Math.pow(10, (239 + 100) / 100) * 0.04093171969) / 100
    return volume * percentage
  }
  getActiveWorkerKeys () {
    return Object.keys(this.volumeNode)
  }
  destroyVolumeNode (key) {
    if (this.volumeNode[key]) {
      console.log(`清理VolumeBar Worker: ${key}`)
      this.volumeNode[key].disconnect()
      this.volumeNode[key].port.close()
      delete this.volumeNode[key]
    }
    if (this.startTime[key]) {
      delete this.startTime[key]
    }
    if (this.callbackMap[key]) {
      delete this.callbackMap[key]
    }
  }
  destroyAudioContext () {
    Object.keys(this.volumeNode).forEach(key => {
      this.volumeNode[key].disconnect()
      this.volumeNode[key].port.close()
      this.startTime[key] = 0
    })
    if (this.audioContext && this.audioContext.state !== 'closed') this.audioContext.close()
  }
}

export default VolumeAudioContext